export default "__VITE_ASSET__D43UkKLF__"